import { useCallback, useEffect, useState } from 'react'

import { getUrgencyVariableForDate } from '../../helpers'
import type {
  ExperimentVariable,
  FeatureVariable,
  UrgencyEntries,
} from '../../types'

export const useUrgency = ({
  entries,
  variables,
}: {
  entries: UrgencyEntries
  variables?: ExperimentVariable
}) => {
  const computeUrgency = useCallback(
    () =>
      Object.entries(entries).reduce(
        (acc, [name, { variableName, variableKey }]) => {
          acc[name] = getUrgencyVariableForDate({
            variableName,
            variableKey,
            variables,
          })

          return acc
        },
        {} as FeatureVariable,
      ),
    [entries, variables],
  )

  const [values, setValues] = useState<FeatureVariable>(computeUrgency())

  useEffect(() => {
    setValues(computeUrgency())
  }, [computeUrgency, entries, variables])

  return values
}
